import { useCallback } from 'react'
import { handleErrors } from './handleErrors'
import { addInHistory, setInContextHelper } from './helpers/setInContextHelper'
import { logger } from '../helpers/logger/logger'

export const useReceiveMessages = ({
  setContext,
  handleNotification,
  handleErrorText,
  setErrorCode,
}: any) => {
  const receiveMessage = useCallback((msg: any) => {
    if (msg === null) return logger.log('receiveMessage msg === null ', msg)
    else if (msg.code) {
      console.error('%cERROR', 'color:aqua', msg)
      handleErrors(msg.code, handleErrorText, handleNotification)
      setErrorCode(msg.code)
    } else {
      switch (msg.service) {
        case 'history':
          return addInHistory(msg.data, setContext)
        case 'settings':
        case 'auth':
        case 'pf':
        case 'config':
        case 'bet':
        case 'bet_reply':
        case 'ping':
          logger.log('%cMSG', 'color:aqua', msg)
          setInContextHelper(msg, setContext)
          break
        case 'disconnect':
          logger.log('%cDISCONNECT', 'color:aqua', msg)
          handleErrors('', handleErrorText, handleNotification)
          break
        default:
          console.error(
            'receiveMessage switch default case',
            msg, // ErrorTypes[msgObject.errorCode],
          )
          break
      }
    }
  }, [])

  return receiveMessage
}
